export type MainNavPage = "nebula" | "map" | "reposition" | "crowdsource" | "growth";

export interface MainNavItem {
  key: MainNavPage;
  label: string;
  description: string;
}

export const MAIN_NAV_ITEMS: readonly MainNavItem[] = [
  { key: "nebula", label: "星云", description: "探索武汉城市记忆知识图谱" },
  { key: "map", label: "地图", description: "浏览历史建筑与文化空间" },
  { key: "reposition", label: "旧影", description: "查看旧照片并重定位历史现场" },
  { key: "crowdsource", label: "共建", description: "投稿并补充城市记忆档案" },
  { key: "growth", label: "生长", description: "观察江城时空生长过程" }
];
